import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoSelfie40 = t0 => {
  const $ = _c(12);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  let t4;
  if ($[2] !== iconColor) {
    t2 = <path d="M13.3332 33.3333H8.33317C7.4127 33.3333 6.6665 32.5871 6.6665 31.6666V26.6666M26.6665 33.3333H31.6665C32.587 33.3333 33.3332 32.5871 33.3332 31.6666V26.6666M6.6665 13.3333V8.33329C6.6665 7.41283 7.4127 6.66663 8.33317 6.66663H13.3332M26.6665 6.66663H31.6665C32.587 6.66663 33.3332 7.41283 33.3332 8.33329V13.3333" stroke={iconColor} strokeWidth={3.333} strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M13.3335 23.3334V16.6667C13.3335 15.7462 14.0797 15 15.0002 15H15.9765C16.4185 15 16.8425 14.8244 17.155 14.5119L17.8453 13.8215C18.1578 13.509 18.5818 13.3334 19.0238 13.3334H20.9765C21.4185 13.3334 21.8425 13.509 22.155 13.8215L22.8453 14.5119C23.1578 14.8244 23.5818 15 24.0238 15H25.0002C25.9207 15 26.6668 15.7462 26.6668 16.6667V23.3334C26.6668 24.2539 25.9207 25 25.0002 25H15.0002C14.0797 25 13.3335 24.2539 13.3335 23.3334Z" stroke={iconColor} strokeWidth={3.333} strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M19.9998 19.75V19.7333M20.8332 19.75C20.8332 20.2101 20.46 20.5833 19.9998 20.5833C19.5397 20.5833 19.1665 20.2101 19.1665 19.75C19.1665 19.2896 19.5397 18.9166 19.9998 18.9166C20.46 18.9166 20.8332 19.2896 20.8332 19.75Z" stroke={iconColor} strokeWidth={3.333} strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ariaLabel || $[7] !== className || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}{t4}</svg>;
    $[6] = ariaLabel;
    $[7] = className;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
export default IcoSelfie40;